/* eslint-disable @angular-eslint/no-output-on-prefix */
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MenuModule } from '@tbtk/menu';
import { TbtkInputComponent } from 'src/app/libs/input/input.component';
import { PathService } from 'src/app/services/path.service';
import { SearchService } from 'src/app/services/search.service';

@Component({
  selector: 'tbtk-search',
  standalone: true,
  imports: [CommonModule, TbtkInputComponent, MenuModule, TranslateModule],
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent {
  @Output() onChange = new EventEmitter<string>();
  @Output() onBlur = new EventEmitter<string>();
  @Output() onFocus = new EventEmitter<string>();
  @Output() onEnter = new EventEmitter<string>();
  @Output() onClick = new EventEmitter<string>();
  @Output() onDetailClick = new EventEmitter<boolean>(true);
  @Input() modalId = '';
  @Input() isMobile = false;
  @Input() value = '';
  public detail = false;

  constructor(public searchService: SearchService, public pathService: PathService) {}

  openFilterModal(event: Event): void {
    event.stopPropagation();
    this.searchService.setDetailSearchVisibility();
  }
}
